var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEyeOutlineGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.5C21.9037 22.5 27.5 15 27.5 15C27.5 15 21.9037 7.5 15 7.5C8.09625 7.5 2.5 15 2.5 15C2.5 15 8.09625 22.5 15 22.5Z",
    stroke: "#497E6B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.125C15.8288 18.125 16.6237 17.7958 17.2097 17.2097C17.7958 16.6237 18.125 15.8288 18.125 15C18.125 14.1712 17.7958 13.3763 17.2097 12.7903C16.6237 12.2042 15.8288 11.875 15 11.875C14.1712 11.875 13.3763 12.2042 12.7903 12.7903C12.2042 13.3763 11.875 14.1712 11.875 15C11.875 15.8288 12.2042 16.6237 12.7903 17.2097C13.3763 17.7958 14.1712 18.125 15 18.125Z",
    stroke: "#497E6B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOutlineGreen);
export default __webpack_public_path__ + "static/media/IconEyeOutlineGreen.5117d633ea565897cc32214b2675d6dc.svg";
export { ForwardRef as ReactComponent };